// Marketing consent (UU PDP). The optional checkbox on every form shows CONSENT_TEXT; a ticked box sends
// consentFields(true) with the form and the backend records it in its consent ledger. CONSENT_VERSION must exist in
// the backend's config/consent.php with the same text: change both together, with a new version name.
export const CONSENT_VERSION = 'mkt-2026-10'

export const CONSENT_TEXT =
  'Saya bersedia menerima info program, promo, dan materi dari Dilatih.co (PT Motekar Edukasi Indonesia) ' +
  'melalui email dan/atau WhatsApp. Saya dapat berhenti kapan saja.'

// Fields to merge into a form's request body. An unticked box adds nothing: no consent is recorded.
export function consentFields(ticked) {
  return ticked ? { marketing_consent: true, consent_version: CONSENT_VERSION } : {}
}
